import * as React from "react";
import { useCallback } from "react";
import Input from "components/bootstrap/Input";
import * as FormsUtils from "util/FormsUtils";
const GenericParameterForm = ({
  idx,
  validationState,
  parameter: { defaultValue },
  onChange
}) => {
  var _a, _b;
  const _onChange = useCallback(
    (e) => {
      const key = e.target.name;
      const value = FormsUtils.getValueFromInput(e.target);
      return onChange(key, value);
    },
    [onChange]
  );
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `default-value-${idx}`,
      type: "text",
      name: "defaultValue",
      label: "Default",
      bsStyle: (_a = validationState == null ? void 0 : validationState.defaultValue) == null ? void 0 : _a[0],
      help: (_b = validationState == null ? void 0 : validationState.defaultValue) == null ? void 0 : _b[1],
      value: defaultValue,
      onChange: _onChange
    }
  );
};
export default GenericParameterForm;
